import {getTextWithHighlight, MarketingText} from 'app/utilities/highlightText';
import classNames from 'classnames';
import React, {useEffect, useState} from 'react';
import {Container} from 'reactstrap';
import {BooleanProperty, NumberProperty, StringProperty} from '@episerver/spa-core/Property';
import TagName from 'app/Components/Shared/TagName';
import HeaderButton from './HeaderButton';

type TeaserProps = {
  texts: MarketingText[];
  isTvContent: boolean;
  titleHeadlineTag?: NumberProperty;
  isShowHeaderButton?: BooleanProperty;
  headerButtonLink?: StringProperty;
  context?: any;
  blockButton?: any;
};

const TeaserTexts = ({texts, isTvContent, titleHeadlineTag, isShowHeaderButton, headerButtonLink,blockButton, context}: TeaserProps) => {
  const [lastShownTextIndex, setLastShownTextIndex] = useState(-1);

  useEffect(() => {
    if (texts.length === 0) return;

    // Show the first text
    setTimeout(() => setLastShownTextIndex(0), 200);

    window.addEventListener('scroll', () => {
      setLastShownTextIndex(Math.min(Math.floor(window.scrollY / 140), texts.length));
    });
  }, [texts.length]);

  return (
    <Container>
      <TagName tagName={titleHeadlineTag?.value} isTitle className={classNames('TeaserTexts', isTvContent ? 'tv-content' : '')}>
        {texts.map((teaserText, i) => (
          <div
            key={i}
            className={classNames(
              'TeaserTexts__text',
              {'TeaserTexts__text--in': i <= lastShownTextIndex},
              isTvContent ? 'tv-content-title' : ''
            )}>
            {getTextWithHighlight(teaserText)}
          </div>
        ))}

        {isShowHeaderButton && isShowHeaderButton.value ? (
          <>
            {' '}
            <div>
              <HeaderButton context={context} headerButtonLink={headerButtonLink} blockButton={blockButton} ></HeaderButton>
            </div>
          </>
        ) : (
          <></>
        )}
      </TagName>
    </Container>
  );
};

export default TeaserTexts;
